const isFilled = (val) => val !== ''

export default isFilled
